import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import {
  BackgroundCheckRequestStatus,
  IBackgroundCheckRequestResponse
} from "@wingspanhq/background-checks/dist/lib/interfaces";
import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";

export const payerBackgroundCheckRenderCardDescription = (
  requirement: IRequirementResponse,
  backgroundCheck?: IBackgroundCheckRequestResponse
) => {
  const descriptions: Record<BackgroundCheckRequestStatus, WSEmptyStateProps> =
    {
      [BackgroundCheckRequestStatus.New]: {
        type: "search",
        title: "Your payer has requested a background check to be completed",
        description:
          "You will receive an email with instructions shortly to start the process."
      },
      [BackgroundCheckRequestStatus.Pending]: {
        type: "search",
        title: "Your payer has requested a background check to be completed",
        description:
          "Click start to open the background check portal in a new window. When you’ve finished with your background check requirement, return to Wingspan to complete your onboarding. You can access the portal and check the status from your Wingspan homepage."
      },
      [BackgroundCheckRequestStatus.Processing]: {
        type: "search",
        title: "Your background check is being processed",
        description:
          "This typically takes 1-3 business days. Your payer will be notified when it is complete."
      },
      [BackgroundCheckRequestStatus.Success]: {
        type: "done",
        title: "Your background check is complete",
        description:
          "You can access the report in the background check portal. Your payer will also be notified."
      },
      [BackgroundCheckRequestStatus.Failed]: {
        type: "search",
        title: "Something went wrong with your background check",
        description: "Please contact your payer to resolve this issue."
      }
    };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: backgroundCheck?.status || BackgroundCheckRequestStatus.New,
    documentStatuses: descriptions,
    pendingApprovalStatus: null,
    rejectedStatus: null,
    approvedStatus: null
  });
};
